import { route } from '@md/routing'
import { accessPermission } from '@md/users/permissions'

const List = () => import('./views/List')
const Display = () => import('./views/Display')

const ROUTE_NAME = 'profile:feed:'

const p = name => ROUTE_NAME + name

const LIST = p('list')
const DISPLAY = p('display')
const GROUP = p('group')

export function createRoutes(options) {
  return [
    route('detail/:id/group/:groupId/', Display, DISPLAY, {
      meta: {
        accessConfig: accessPermission([
          'parent', 'company', 'child', 'employee', 'teacher', 'manager',
          'student',
        ], options),
      },
      props: true,
    }),
    route('group/stream/:feed/', Display, GROUP, {
      meta: {
        accessConfig: accessPermission([
          'parent', 'company', 'child', 'employee',
          'student',
        ], options),
      },
      props: true,
    }),
    route('list/', List, LIST, {
      meta: {
        accessConfig: accessPermission([
          'manager', 'teacher',
        ], options),
      },
    }),
    { path: '*', redirect: { name: LIST } },
  ]
}
